export default __webpack_public_path__ + "static/media/react-logo.6bcffb56.png";